<template>
	<div>
		<a v-show="showPlayStoreButton"
			:href="linkPlayStore"
			style="margin-right: 1.9mm;"
		>
			<img class="height"
					:src="playStoreButtonImageSource"
					:alt="playStoreButtonImageAlt"
			/>
		</a>
		<a :href="linkAppStore" v-show="showAppStoreButton">
			<img class="height"
					:src="appStoreButtonImageSource"
					:alt="appStoreButtonImageAlt"
			/>
		</a>
	</div>
</template>

<script>
import GetItOnGooglePlay_SE from '../assets/img/MobileStoreButtons/GetItOnGooglePlay/GetItOnGooglePlay_Badge_Web_color_Swedish.png';
import GetItOnGooglePlay_EN from '../assets/img/MobileStoreButtons/GetItOnGooglePlay/GetItOnGooglePlay_Badge_Web_color_English.png';
import GetItOnGooglePlay_PL from '../assets/img/MobileStoreButtons/GetItOnGooglePlay/GetItOnGooglePlay_Badge_Web_color_Polish.png';
import GetItOnGooglePlay_FR from '../assets/img/MobileStoreButtons/GetItOnGooglePlay/GetItOnGooglePlay_Badge_Web_color_French.png';

import DownloadOnTheAppStore_SE      from '../assets/img/MobileStoreButtons/DownloadOnTheAppStore/Download_on_the_App_Store_Badge_SE_RGB_blk_100317.svg';
import DownloadOnTheAppStore_SE_dark from '../assets/img/MobileStoreButtons/DownloadOnTheAppStore/Download_on_the_App_Store_Badge_SE_RGB_wht_100317.svg';
import DownloadOnTheAppStore_EN      from '../assets/img/MobileStoreButtons/DownloadOnTheAppStore/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import DownloadOnTheAppStore_EN_dark from '../assets/img/MobileStoreButtons/DownloadOnTheAppStore/Download_on_the_App_Store_Badge_US-UK_RGB_wht_092917.svg';
import DownloadOnTheAppStore_PL      from '../assets/img/MobileStoreButtons/DownloadOnTheAppStore/Download_on_the_App_Store_Badge_PL_RGB_blk_100317.svg';
import DownloadOnTheAppStore_PL_dark from '../assets/img/MobileStoreButtons/DownloadOnTheAppStore/Download_on_the_App_Store_Badge_PL_RGB_wht_100317.svg';
import DownloadOnTheAppStore_FR      from '../assets/img/MobileStoreButtons/DownloadOnTheAppStore/Download_on_the_App_Store_Badge_FR_RGB_blk_100517.svg';
import DownloadOnTheAppStore_FR_dark from '../assets/img/MobileStoreButtons/DownloadOnTheAppStore/Download_on_the_App_Store_Badge_FR_RGB_wht_100217.svg';

export default {
	name: 'MobileStoreButtons',

	props: {
		forceShow: {
			type:    Boolean,
			default: false,
		},
	},

	data: () => ({
		linkPlayStore: 'https://play.google.com/store/apps/details?id=se.datavara.cronaportal',
		linkAppStore:  'https://apps.apple.com/se/app/crona-portal/id1557570009',
	}),

	computed: {
		showPlayStoreButton() {
			return (!this.isMobileApp && !this.isDeviceIOS) ||
				(this.isMobileApp && this.forceShow && !this.isDeviceIOS);
		},

		playStoreButtonImageSource() {
			let source;

			switch(this.$vuetify.lang.current) {
				case 'sv': source = GetItOnGooglePlay_SE; break;
				case 'en': source = GetItOnGooglePlay_EN; break;
				case 'pl': source = GetItOnGooglePlay_PL; break;
				case 'fr': source = GetItOnGooglePlay_FR; break;
			}

			return source;
		},

		playStoreButtonImageAlt() {
			return this.$t('MobileStoreButtons.GetItOnGooglePlay');
		},

		showAppStoreButton() {
			return (!this.isMobileApp && !this.isDeviceAndroid) ||
				(this.isMobileApp && this.forceShow && !this.isDeviceAndroid);
		},

		appStoreButtonImageSource() {
			let source;

			switch(this.$vuetify.lang.current) {
				case 'sv': source = this.$vuetify.theme.dark ? DownloadOnTheAppStore_SE_dark : DownloadOnTheAppStore_SE; break;
				case 'en': source = this.$vuetify.theme.dark ? DownloadOnTheAppStore_EN_dark : DownloadOnTheAppStore_EN; break;
				case 'pl': source = this.$vuetify.theme.dark ? DownloadOnTheAppStore_PL_dark : DownloadOnTheAppStore_PL; break;
				case 'fr': source = this.$vuetify.theme.dark ? DownloadOnTheAppStore_FR_dark : DownloadOnTheAppStore_FR; break;
			}

			return source;
		},

		appStoreButtonImageAlt() {
			return this.$t('MobileStoreButtons.DownloadOnTheAppStore');
		},
	},
}
</script>

<style scoped>
	.height {
		height: 7.6mm !important;
	}
</style>
